import AssignmentService from "@/assignments/assignmentsService.js";

export default {
  Assign() {
    this.$set(this, "currentAssignmentType", null);
    this.$set(this, "isAssignmentEditing", true);
  },
  MarkComplete(embedItem) {
    var instance = this;
    var assignmentToComplete = embedItem.AllAssignments.filter(
      (a) => a.CreatedForUserId == this.currentUser.User.Id
    );
    if (assignmentToComplete != null && assignmentToComplete.length > 0) {
      assignmentToComplete.forEach((assignment) => {
        if (assignment.State !== 3) {
          AssignmentService.completeAssignment(assignment).then(function () {
            instance.$vs.notify({
              title: "Success!",
              text: "The assignment was marked as completed.",
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }); // Could be more than 1 assingment.
        }
      });
    } else {
      // create and complete.
    }
  },
  isAssignmentUpdated(val) {
    this.$set(this, "isAssignmentEditing", val);
  },

  SaveAssignment() {
    this.$set(this, "isAssignmentEditing", false);
  },
  GetInProgressAssignments(assignmentArray) {
    return assignmentArray.filter((itm) => itm.State < 3);
  },
  GetCompletionAssignments(assignmentArray) {
    return assignmentArray.filter((itm) => itm.State == 3);
  },
  GiveFeedback() {
    var instance = this;
    this.currentAssignmentType = "Improvement Request";
    this.$nextTick(function () {
      instance.isAssignmentEditing = true;
    });
  },
}
